import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false // NOSONAR
})
export class ToolbarComponent implements OnInit {
  @ViewChild('home') private home: RouterLinkActive; // NOSONAR
  enableHomeGrey = false;
  enableHomeRed = true;
  activeHome: boolean = false;
  event: any;

  constructor(private readonly router: Router) { }

  ngOnInit(): void { // NOSONAR

   }

  ngOnDestroy() { // NOSONAR
    this.event.unsubscribe();
  }

  ngAfterContentChecked(): void { // NOSONAR
    this.makeAllFalse();
    if (this.router.url == '/' || this.router.url == '/home') { // NOSONAR
      this.enableHomeRed = true;
      this.enableHomeGrey = false;
      this.activeHome = true;
    }
  }

  makeAllFalse() {
    this.activeHome = false;
    this.enableHomeRed = false;
    this.enableHomeGrey = true;
  }
}